<template>
    <div class="multi-switcher new-chat-source-filter">
        <div class="multi-switcher__switch button_type_static button_color_transp-black">
            <div class="multi-switcher__content">
                <button
                    v-for="option in options"
                    :key="option.value"
                    class="button button_type_static"
                    :class="{ 'button_color_black': value === option.value }"
                    @click="$emit('input', option.value)"
                >
                    {{ option.label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewChatSourceFilter',
    props: {
        value: {
            type: String,
            default: 'regular'
        }
    },
    data() {
        return {
            options: [
                { value: 'regular', label: 'Обычные' },
                { value: 'ai',      label: 'AI' },
                { value: 'all',     label: 'Все' },
            ]
        }
    }
}
</script>

<style lang="scss">
.new-chat-source-filter {
    width: 100%;

    .multi-switcher__switch {
        width: 100%;
    }

    .multi-switcher__content {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;

        .button {
            flex: 1 1 auto;
            text-align: center;
        }
    }
}
</style>
